export const FCMTOKENKEY='MalikNe_Bola@Krne!Ka1_To3Krne_Ka'
export const IV='3f5a9e76a1c94e1b'
// # the secret key should of 32 bytes